import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'org/:organization-id/queue',
    loadChildren: () => import('./pages/queue/list/queue.module').then( m => m.QueuePageModule)
  },
  {
    path: 'org/:organization-id/agents',
    loadChildren: () => import('./pages/agent/list/agent.module').then( m => m.AgentPageModule)
  },
  {
    path: 'org/:organization-id/analytics',
    loadChildren: () => import('./pages/analytics/analytics.module').then( m => m.AnalyticsPageModule)
  },
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true, enableTracing: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
